import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import theme from '@styles/Theme'
// import { media } from '@utils/mediaQuery'

const GlobalStyle = createGlobalStyle`

  /* normalize css */
  ${reset}

  *, ::after, ::before {
    box-sizing: border-box;
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  /* body default */
  html {
    overflow: hidden;
  }

  body {
    background-color: black;
    padding: 0;
    margin: 0;
    font-family: ${theme.fontFamily};
    font-weight: 300;
    color: black;
    width: 100vw;
    position: relative;
    overflow: hidden;
  }

  /* headings */
  h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
    margin-bottom: ${theme.spaceDefault}px;
    /* font-family: ${theme.fontFamilyHeadings}; */
    font-weight: 700;
    text-transform: uppercase;
  }

  em, i {
    font-style: italic;
  }

  strong {
    font-weight: 600;
  }

  h1, .h1 {
    font-size: ${theme.headings.h1};
  }

  h2, .h2 {
    font-size: ${theme.headings.h2};
  }

  h3, .h3 {
    font-size: ${theme.headings.h3};
  }

  h4, .h4 {
    font-size: ${theme.headings.h4};
  }

  h5, .h5 {
    font-size: ${theme.headings.h5};
  }

  h6, .h6 {
    font-size: ${theme.headings.h6};
  }

  /* paragraph */
  p {
    margin-bottom: ${theme.spaceDefault}px;
  }

  /* list */
  ul, ol {
    margin-bottom: ${theme.spaceDefault}px;
  }

  /* link */
  a {
    color: white;
  }


`

export default GlobalStyle
